import React from "react";

import "./UploadPage.scss";

const UploadPage: React.FC = () => {
  return <div>UploadPage</div>;
};

export default UploadPage;
